import BasePageApprove from '../../../../../modules/table_page_approve';
import Table from './table';

export default {
  extends: BasePageApprove,
  components: {
    Table,
  },
};
